import { render, staticRenderFns } from "./InputSigarusHidden.vue?vue&type=template&id=a8e5d928"
import script from "./InputSigarusHidden.vue?vue&type=script&lang=js"
export * from "./InputSigarusHidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports